// extracted by mini-css-extract-plugin
export var cardWrapper = "_5r-0";